<template>
    <div component="ContractTemplate" template="page" v-if="loading">
        <div class="bg">
            <v-dialog v-model="removeDialog" persistent max-width="290">
                <v-card>
                    <v-card-title class="text-h5">Confirm</v-card-title>
                    <v-card-text>Are you sure you want to delete this contract?</v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="removeDialog = false"> No </v-btn>
                        <v-btn color="blue darken-1" text @click="remove"> Yes </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog v-model="sendDialog" persistent max-width="290">
                <v-card>
                    <v-card-title class="text-h5">Confirm</v-card-title>
                    <v-card-text>Do you really want to submit this contract?</v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="sendDialog = false"> No </v-btn>
                        <v-btn color="blue darken-1" text @click="send"> Yes </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-card class="holder">
                <v-snackbar class="text-center" centered v-model="showStatusSave" timeout="1900">
                    <h3 class="success text-center" v-if="saveStatus">Template was saved.</h3>
                    <h3 class="error text-center" v-else>There was error saving template.</h3>
                </v-snackbar>

                <v-snackbar class="text-center" centered v-model="showStatusSubmitting" timeout="1900">
                    <h3 class="success text-center" v-if="submittingStatus">Contract was submitted.</h3>
                    <h3 class="error text-center" v-else>There was error submitting contract.</h3>
                </v-snackbar>

                <div class="header">
                    <div class="column">
                        <div>
                            {{ contract.project.nazov }}
                        </div>
                        <div>
                            <strong>{{ contract.actor.meno_priezvisko }}</strong>
                        </div>
                    </div>

                    <div class="column">
                        <div>Created</div>
                        <div>
                            {{ dateFormat(contract.date) }}
                        </div>
                    </div>

                    <div class="column">
                        <div>Sent</div>
                        <div>
                            {{ dateFormat(contract.sent) }}
                        </div>
                    </div>

                    <div class="buttons">
                        <a class="button camera" color="base" @click="saveTemplate">
                            <i class="icon">save</i>
                            <span>SAVE</span>
                        </a>

                        <a class="button camera" color="secondary" @click="sendDialog = true">
                            <i class="icon">mail</i>
                            <span>SEND</span>
                        </a>

                        <a class="button camera" color="accent" @click="removeDialog = true">
                            <i class="icon">do_not_disturb_on</i>
                            <span>DELETE</span>
                        </a>

                        <a class="button" radius="circle" @click="goToContract">
                            <i class="icon">close</i>
                        </a>
                    </div>
                </div>

                <ckeditor v-model="template" :config="editorConfig" class="editor"></ckeditor>
            </v-card>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import moment from '~/moment';

export default {
    name: 'ContractTemplate',

    data() {
        return {
            loading: false,
            removeDialog: false,
            sendDialog: false,
            editorConfig: {
                extraAllowedContent: '*[*]{*}(*)',
                entities: false,
                basicEntities: false,
                forceSimpleAmpersand: true,
                height: '100%',
            },
            templateBackup: null,
            showStatusSave: false,
            saveStatus: false,
            showStatusSubmitting: false,
            submittingStatus: false,
        };
    },

    async mounted() {
        await this.loadContract(this.$route.params.id);
        this.loading = true;
        this.backup_template = this.contract.text;
    },

    methods: {
        ...mapMutations({
            setContract: 'setContractDetail',
        }),

        ...mapActions({
            loadContract: 'loadContractDetail',
            storeContract: 'storeContractDetail',
            removeContract: 'removeContract',
            submitContract: 'submitContract',
        }),

        async remove() {
            this.removeDialog = false;
            await this.removeContract(this.contract.id);
            this.$router.go(-1);
        },

        async send() {
            this.sendDialog = false;
            const submittingStatus = await this.submitContract(this.contract.id);
            this.showStatusSubmitting = true;
            this.submittingStatus = submittingStatus;
            await this.loadContract(this.$route.params.id);
        },

        dateFormat(date) {
            if (!date || date === '0000-00-00 00:00:00') {
                return '-';
            }

            return moment(date).format('DD.MM.YYYY');
        },

        async saveTemplate() {
            const saveStatus = await this.storeContract();
            this.showStatusSave = true;
            this.saveStatus = saveStatus;
        },

        goToContract() {
            this.$router.go(-1);
            // this.$router.push({path: '/contract'}).catch(() => {
            // });
        },
    },

    computed: {
        ...mapGetters({
            contract: 'getContractDetail',
        }),

        template: {
            get() {
                return this.contract.text;
            },
            set(val) {
                this.setContract({
                    ...this.contract,
                    text: val,
                });
            },
        },
    },
};
</script>

<style lang="less" scoped>
@import '~@variables';

[component='ContractTemplate'] {
    height: 100vh;
    max-height: 100vh;

    .holder {
        min-height: 100%;
        display: flex;
        flex-direction: column;
        padding: 20px 20px 10px;
        .radiusBig !important;
    }

    .header {
        margin-bottom: 4rem;
        align-items: center;
        display: flex;
        gap: 3rem;

        .column {
            display: flex;
            gap: 0.25rem;
            flex-direction: column;
        }

        .buttons {
            margin-left: auto;
        }
    }
}

.editor {
    display: flex;
    flex: 1;
}

/deep/.cke_chrome {
    flex: 1;
    display: flex;
    flex-direction: column;

    .cke_inner.cke_reset {
        flex: 1;
        min-height: 800px;
        display: flex;
        flex-direction: column;

        #cke_1_contents {
            min-height: 800px;
            flex: 1 !important;
        }
    }
}
</style>
